export default "__VITE_ASSET__CiAA2rbL__"